<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <!-- <li><a routerLink="/partnership">Partnership Opportunities</a></li> -->
                            <!-- <li><a routerLink="/officialpartners" class="">Official Partners</a></li> -->
                            <!-- <li><a routerLink="/players-sponsor">Entry Level Sponsorship</a></li> -->
                            <!-- <li><a routerLink="/commercial" >Captain’s Club </a></li> -->
                            <!-- <li><a routerLink="/boundary">The Boundary Club</a></li> -->
                            <!--<li><a routerLink="/advertising">LED Big Screen Advertising</a></li>-->
                            <!-- <li><a routerLink="/indiafixture">India Fixture</a></li> -->
                            <li><a routerLink="/hospitality" class="active">Match Day Hospitality</a></li>
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="commercial-bottom-section cf">
        <div class="commercial-bottom-content">
            <div class="container">
                <!-- <div class="membership-hero-detail hospitality-bottom cf">
                    <div class="membership-new-top-section">
                        <iframe src="https://player.flipsnack.com?hash=Qzg3QkVDQkJEQzkreG1zdjgzcGQxag==" width="100%" height="480" seamless="seamless" scrolling="no" frameBorder="0" allowFullScreen allow="autoplay; clipboard-read; clipboard-write"></iframe>
                    </div>             
                </div>  -->
                <div class="commercial-president-main-section cf">                   
                    <div  class="commercial-president-section cf" *ngFor="let hospitality of hospitalityList?.data">
                        <div  class="commercial-president-image-box"><img [src]="hospitality?.image"></div>
                        <div  class="commercial-president-content-box">
                           <div  class="titel-box">
                              <h2 class="titel-name">{{hospitality?.title}}</h2>
                           </div>
                           <div class="commercial-president-content" [innerHTML]="hospitality?.description">
                              
                           </div>
                           <!--<div  class="commercial-president-btn" *ngIf="hospitality?.pdf"><a  href="{{hospitality?.pdf}}" download>Click HERE for full package</a>&nbsp; <a  href="https://leicestershireccchospitality.seatunique.com/" target="_blank">BUY Hospitality</a></div>-->
                          
                        </div>
                    </div>
                    
                </div>
                <div class="commercial-contact-us-section cf" *ngIf="contentList">
                    <div class="titel-box">
                        <h2 class="titel-name">{{contentList?.title}}</h2>
                    </div>
                    <div class="commercial-contact-content" [innerHTML]="contentList?.description">
                        <p>Leicestershire County Cricket Club recognises that you have a choice when it comes to booking an event. We offer a personal touch alongside our first-class facilities. </p>
                        <p> The club's Catering Manager John Stew and Hospitality Manager Zoe Draycott would be delighted to discuss your event requirements and arrange a tour of our facilities at Grace Road.</p>
                        <a href="javascript:void(0)"> e - enquiries@leicestershireccc.co.uk</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/player-bg-img.png);">
            <div class="container">
                <div class="commercial-bottom-contact-detail">
                    <form class="commercialform " #contactusForm="ngForm" (ngSubmit)="clubContactus(contactusForm)" [ngClass]="{'success': contactSuccess}">
                        <http-message types="success" [data]="contactSuccess" class="err-msg-block">
                        </http-message>
                        <http-message [type]="'error'" [data]="contactError" *ngIf="contactError"
                           class="err-msg-block"></http-message>
                        
                        <div class="join-register-right-box">
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="first_name" [(ngModel)]="contactRequest.first_name"
                            class="app-group">
                                        <input appFieldInput class="register-style" placeholder="First Name" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="last_name" [(ngModel)]="contactRequest.last_name"
                            class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Last Name" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="email" [(ngModel)]="contactRequest.email"
                            class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Email Address" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="mobile_number" [(ngModel)]="contactRequest.mobile_number"
                            class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Mobile No" type="number">
                                </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="company_name" [(ngModel)]="contactRequest.company_name"
                            class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Company Name" type="text">
                                </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="type_of_event" [(ngModel)]="contactRequest.type_of_event"
                            class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Type of event" name="type_of_event" type="text" >
                                </app-form-field>
                                </div>
                                <div class="join-register-right-box-input full">
                                    <app-form-field validation="required" name="message" [(ngModel)]="contactRequest.message"
                            class="app-group">
                                        <textarea appFieldInput name="message" form="usrform" class="register-style" placeholder="Message">Message</textarea>
                                    </app-form-field>
                                </div>
                        </div>
                        <div class="join-register-right-box">
                           <div class="join-register-btn"><button id="reg_button" type="submit">Submit</button></div>
                        </div>
                     </form>
                </div>
            </div>
            <div class="commercial-bottom-contact-overlay"></div>
        </div>
       
    </div>
</section><!-- page ends-->